<template>
  <panel
    :breadcrumbs="breadcrumbs"
    :title="title"
  >
    <tnc
      v-for="item in tncs"
      :key="item.title"
      v-model="item.show"
      :content="item"
    />
    <v-card>
      <v-toolbar
        extension-height="10"
        color="grey darken-4"
        dark
      >
        <v-toolbar-title>Jom Bantu</v-toolbar-title>
      </v-toolbar>
      <v-list>
        <v-list-group
          v-for="item in items"
          :key="item.title"
          :prepend-icon="item.icon"
          no-action
        >
          <template #activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :href="subItem.link"
            target="_blank"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </panel>
</template>

<script>
import { createGetParams } from '@/rest'
const pageTitle = 'Document To Download'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
    Tnc: () => import(/* webpackChunkName: "tncjombantu" */ '@/components/TncJomBantu'),
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Jom Bantu', disabled: false, to: '/jombantu',
        },
        {
          text: pageTitle, disabled: true,
        },
      ],
      title: pageTitle,
      tncs: [],
      tnc: [],
      items: [],
      loading: false,
    }
  },
  created: function () {
    this.getTnc()
    const params = createGetParams({})
    this.$rest.get('getDocumentJomBantu.php', params)
      .then((response) => {
        this.items = response.data
      }).catch(error => {
        console.log(error)
      })
  },
  mounted: function () {
  },
  methods: {
    getTnc: function () {
      const params = createGetParams({})
      this.loading = true
      this.$rest.get('getJomBantuTnc.php', params)
        .then(response => {
          this.tncs = response.data
        }).catch(e => {
          this.tncs = []
        })
    },
  },
}
</script>
